'use strict';

const {TRACKING} = require('components/membership/membership_ancillaries/js/constants');
const {trackOncePerPolicy} = require('od-modules/track_events/track.frontevents.additional.products');
const {trackClickEvent, trackDOMElementDisplayed} = require('od-modules/track_events/track.frontevents.utils');

const trackingUtils = require('../utils/tracking.utils');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();
const store = require('od-modules/secure_store/store');
const {isPrimeAccount} = require('od-modules/utils/membership_utils');
const tagManagement = require('../utils/tag_management.utils');

const ancillariesStepNamespace = '.ancillariesStep';
const continueToPrimeWidgetNamespace = '.primeWidgetAncillariesStep';
const continueToPaymentFormNamespace = '.paymentFormAncillariesStep';
const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
const isUserLogged = () => hasRememberMeCookie();

const widgets = Odigeo.autoloadWidgets({
    getServiceoptionsTableManager: ['so-table', 'service_options_table'],
});

const widgetsAsync = Odigeo.autoloadWidgetsAsync({
    getAncillariesModule: ['ancillaries-module', 'ancillaries_module'],
});

const $payment = $('#payment');
const $selectors = {
    paymentContinueButton: '.payment_continue_button',
    payWithGuaranteeButton: '.pay_with_guarantee_button',
    payWithGuaranteeNormalButton: '.pay_with_guarantee_normal_button',
    paymentForm: $payment.find('.payment_pay_module'),
    paymentFormRevamp: $payment.find('.payment_pay_module_revamp'),
    stepButton: $payment.find('.ancillaries_step_button'),
    stepButtonContainer: $payment.find('.ancillaries_step_button_container'),
    // test AB cop-702
    ancillariesButton: $payment.find('.show_ancillaries_button'),
    ancillariesBlock: $payment.find('.ancillaries_block'),
    // end test AB cop-702
    ancillariesModule: $payment.find('#ancillaries-module'),
    stepButtonContainerTitle: $payment.find('.ancillaries_step_title'),
    stepButtonContainerSubtitle: $payment.find('.ancillaries_step_subtitle'),
    stepButtonChangeFlightFreeChargeContainerText: $payment.find('.flights_change_free_message'),
    membershipAncillariesWidget: $('#membership-ancillaries'),
    continueToPrimeWidgetButton: $('.ancillaries_step_membership_button'),
    continueToPrimeWidgetButtonContainer: $('.ancillaries_step_membership_button_container'),
    continueToPaymentFormButton: $('.ancillaries_step_continue_to_payment_form_button'),
    continueToPaymentFormButtonContainer: $('.ancillaries_step_continue_to_payment_form_button_container'),
    membershipFlexibilitySidebar: $('.membership_flexibility_sidebar'),
    membershipFlexibilityButtonLabelIncluded: $('.membership_flexibility_button_label_included'),
    membershipFlexibilityButtonLabelExcluded: $('.membership_flexibility_button_label_excluded'),
    membershipFlexibilityTripDetails: $('.flight_flexibility_banner'),
    oldPrimeModuleSection: $('.old_prime_module_section'),
    oldMembershipAutoApplyDiscount: $('#membership-auto-apply-discount'),
};

let isPrimeWidgetStepOpenFirstTime;
const isPrimeWidgetStepOpenFirstTimeSessionItem = 'isPrimeWidgetStepOpenFirstTime';
let isAncillaryStepOpenFirstTime;
const isAncillaryStepOpenFirstTimeSessionItem = 'isAncillaryStepOpenFirstTime';
let skipInsurancesContinueNagByRebooking;
let skipInsurancesContinueNagByCanx;
let isPrimeModuleFromShell = false;

const getPrimeWidgetStepOpenFirstTimeSessionItem = () => {
    return Odigeo.Utils.parseJson(Odigeo.Session.get(isPrimeWidgetStepOpenFirstTimeSessionItem));
};

const getAncillaryStepOpenFirstTimeSessionItem = () => {
    return Odigeo.Utils.parseJson(Odigeo.Session.get(isAncillaryStepOpenFirstTimeSessionItem));
};

const initFlags = () => {
    isPrimeWidgetStepOpenFirstTime = getPrimeWidgetStepOpenFirstTimeSessionItem();
    isAncillaryStepOpenFirstTime = getAncillaryStepOpenFirstTimeSessionItem();
    skipInsurancesContinueNagByRebooking = false;
    skipInsurancesContinueNagByCanx = false;
};

const setForm = () => {
    if (isStepClosedByDefault() && !Odigeo.AB.isMoveProductsModule) {
        hidePaymentForm();
        bindStepButtonClickEventEvo();
    } else {
        openStep();
    }
    if (isPrimeModuleFromShell && isPrimeWidgetStep()) {
        toggleShowSubscriptionManagerDesktopContainer();
    }
    if (isPrimeWidgetStep()) {
        bindContinueToPrimeWidgetButtonClickEvent();
        bindContinueToPaymentFormClickEvent();
        if (isPrimeWidgetStepClosedByDefault() && isStepClosedByDefault()) {
            toggleContinueToPrimeWidgetButton(true);
            hideStepButton();
        } else if (!isPrimeWidgetStepClosedByDefault() && isStepClosedByDefault()) {
            toggleContinueToPrimeWidgetButton(false);
            toggleContinueToPaymentFormButton(true);
            hideStepButton();
        } else {
            toggleContinueToPrimeWidgetButton(false);
            toggleContinueToPaymentFormButton(true);
            hidePaymentForm();
        }
    }
};

const initStep = () => {
    if (isAncillariesStepEnabled()) {
        initFlags();
        setForm();

        trackDOMElementDisplayed($payment.find('.ancillaries_continue_button_load')[0]);

        if (Odigeo.Membership.isMembershipFlexibilityD) {
            toggleMembershipFlexibility();
        } else {
            updateFreeCanxTextsVisibility();
        }
    }
};

const openPrimeWidgetStep = (addSoBasic) => {
    trackingUtils.trackEvent('prime_continue_button', 'continue_to_payment_button_prime:onload', 'flights_ancillaries_page');

    addSoBasicIfNotAdded(addSoBasic);
    setPrimeWidgetStepHasAlreadyOpened(true);
    if (isPrimeModuleFromShell) {
        toggleShowSubscriptionManagerDesktopContainer();
        scrollToSubscriptionManagerDesktopContainer();
    } else {
        toggleShowMembershipAncillariesWidget();
        if (Odigeo.Membership.isPrimeRecaptureCustomersDesktop || isPrimeRecaptureCustomersDesktopStore()) {
            toggleShowMembershipRecaptureWidget();
        }
    }
    toggleContinueToPrimeWidgetButton(false);
    toggleContinueToPaymentFormButton(true);
};

const openStep = (addSoBasic) => {
    addSoBasicIfNotAdded(addSoBasic);
    hideStepButton();
    const radioButtonsPrimeSelected = $payment.find('.membership_ancillaries_radio_input');
    if (isPrimeModuleFromShell) {
        toggleMembershipAutoApplyDiscount(false);
    }
    if (!isPrimeModuleFromShell && radioButtonsPrimeSelected.length > 0) {
        const isPrimeSelected = radioButtonsPrimeSelected.is(':checked');
        if (isPrimeSelected) {
            trackContinueButton();
            showPaymentForm();
        } else {
            toggleContinueToPaymentFormButton(true);
        }
    } else {
        showPaymentForm();
    }
    if (!isPrimeWidgetStep()) {
        trackingUtils.trackEvent('ancillaries_step', 'proceed_to_payment', 'ancillaries');
        trackPrice();
    }
    Odigeo.trigger('ancillariesStep:opened');
};

const isPrimeWidgetStepClosedByDefault = () => Odigeo._.isNull(isPrimeWidgetStepOpenFirstTime);

const isStepClosedByDefault = () => Odigeo._.isNull(isAncillaryStepOpenFirstTime);

const setPrimeWidgetStepHasAlreadyOpened = (isPrimeWidgetStepOpenFirstTime = false) => {
    Odigeo.Session.set(isPrimeWidgetStepOpenFirstTimeSessionItem, isPrimeWidgetStepOpenFirstTime);
};

const setStepHasAlreadyOpened = () => {
    isAncillaryStepOpenFirstTime = false;
    Odigeo.Session.set(isAncillaryStepOpenFirstTimeSessionItem, isAncillaryStepOpenFirstTime);
};

const trackContinueButton = () => {
    const {data = {}} = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData')) || {};
    const {priceWithoutDiscountSelected = false} = data;
    const primeFareSelectedLabel = priceWithoutDiscountSelected ? 'no-prime' : 'prime';
    const trackingInfo = `${primeFareSelectedLabel}${isUserLogged() ? '-log' : ''}`;
    trackingUtils.trackEventWithCategory(TRACKING.CATEGORY, TRACKING.ACTIONS.PRIME,
        `continue_with_${getSelectedOption()}_sce:${trackingInfo}_pag:anc`);
};

const getSelectedOption = () => {
    const $radioInputs = $payment.find('.membership_ancillaries_radio_input');
    const [isPrimeSelected, isFullFareSelected] = ['PRIME_FARE', 'FULL_FARE']
        .map((offer) => $radioInputs.filter((i, domEl) => domEl.dataset.offer === offer))
        .map(($offerInput) => $offerInput.is(':checked'));
    return isPrimeSelected && !isFullFareSelected ? 'prime' : 'standard';
};

const isSkipByGuarantees = () => skipInsurancesContinueNagByRebooking || skipInsurancesContinueNagByCanx;

const checkMandatorySelection = () => {
    if (Odigeo.getWidgetByID('ancillaries-module')) {
        checkMandatorySelectionAncillariesModule();
    } else {
        openStep(true);
    }
};

const getValidationType = (validationError) => Odigeo._.get(validationError, 'validationType', 'none');

const handleMandatorySelection = (validationError) => {
    const validationInvalid = Odigeo._.get(validationError, 'invalid', false);

    switch (getValidationType(validationError)) {
        case 'MANDATORY_SELECTION':
            return handleMandatorySelectionYesNo(validationInvalid);
        case 'NAG':
            return handleMandatorySelectionContinueNag(validationInvalid);
    }

    isPrimeWidgetStep() ? openPrimeWidgetStep() : openStep(true);
};

const getValidateSelection = () => widgetsAsync.getAncillariesModule().get('validateSelection', isYesNoEnabled());

const checkMandatorySelectionAncillariesModule = () => {
    getValidateSelection().done((validationError) => {
        handleMandatorySelection(validationError);
    });
};

const handleMandatorySelectionContinueNag = (invalid) => {
    if (!isSkipByGuarantees() && invalid) {
        widgetsAsync.getAncillariesModule().execute('showContinueNag');
    } else {
        isPrimeWidgetStep() ? openPrimeWidgetStep() : openStep(true);
    }
};

const getFirstFailedAncillaryElement = () => {
    return $selectors.ancillariesModule.find('.mandatory_selection_error').first().closest('.insurance_element');
};

const handleMandatorySelectionYesNo = (invalid) => {
    if (invalid) {
        Odigeo.Utils.scrollToElement(getFirstFailedAncillaryElement());
    } else {
        widgetsAsync.getAncillariesModule().execute('rejectSelectionForUnSelectedSingleProducts');
        openStep(true);
    }
};

const isYesNoEnabled = () => Odigeo._.get(Odigeo.getWidgetByID('ancillaries-module'), 'options.page') === 'selection';

const trackOnLoadPaymentButtons = () => {
    const hasButtonWithGuarantee =
        $payment.find($selectors.payWithGuaranteeButton).length ||
        $payment.find($selectors.payWithGuaranteeNormalButton).length;

    const paymentContinueButton = $payment.find('.payment_continue_button_load');

    if (paymentContinueButton.length) {
        trackingUtils.trackEvent('payment_continue_button', 'payment_continue_button_load:y', 'flights_pay_page');
        trackDOMElementDisplayed(paymentContinueButton[0]);
    }

    if (hasButtonWithGuarantee) {
        trackingUtils.trackEvent('payment_continue_button', 'payment_continue_button_load:r', 'flights_pay_page');
        trackDOMElementDisplayed($payment.find('.ancillaries_payment_continue_button_load')[0]);
    }
};

const showPaymentForm = () => {
    setTimeout(()=> {
        calculatePriceDifferenceBtwSidebarAndPbd();
    }, 360);

    setTimeout(()=> {
        trackOnLoadPaymentButtons();
    }, 1000);

    return $selectors.paymentForm.fadeIn(350) && $selectors.paymentFormRevamp.fadeIn(350);
};

const hidePaymentForm = () => $selectors.paymentForm.fadeOut() && $selectors.paymentFormRevamp.fadeOut();

const hideStepButton = () => {
    $selectors.stepButton.addClass('odf-hidden');
    $selectors.stepButtonContainer.addClass('odf-hidden');
    tagManagement.fireExternalEvent('qualtrics', 'clickon_continuetopayment_FL');
};

const calculatePriceDifferenceBtwSidebarAndPbd = () => {
    const isMeta = Odigeo.SessionScope.isMeta;
    let pbdTotalPrice = $payment.find('.regular_total_price').data('total-price') || 0;
    pbdTotalPrice = pbdTotalPrice.toFixed(2);
    let sidebarTotalPrice = !isMeta ? $payment.find('.total_price_sidebar_selector').data('total-price')
        : $payment.find('.total_price_sidebar_selector').text();
    sidebarTotalPrice = sidebarTotalPrice ? sidebarTotalPrice.replace(/\D/g, '') : '0';
    sidebarTotalPrice =
        parseFloat(`${sidebarTotalPrice.slice(0, sidebarTotalPrice.length -2)}.${sidebarTotalPrice.slice(-2)}`);
    sidebarTotalPrice = sidebarTotalPrice.toFixed(2);
    const difference = Number.parseFloat(pbdTotalPrice) - Number.parseFloat(sidebarTotalPrice);
    trackPbdAndSidebarTotalPrice(difference);
};

const trackPbdAndSidebarTotalPrice = (difference) => {
    if (difference > 1 || difference < -1) {
        trackingUtils.trackEvent('ancillaries_step', `proceed_to_payment_with_${difference}_amount_difference`, 'ancillaries');
    }
};

const trackPrice = () => {
    const totalPrice = Number($payment.find('.od-price-summary-total-tickets').text().replace(/[^0-9.-]+/g, ''));
    if (totalPrice <= 0) {
        trackZeroTotalPrice();
    }
};

const trackZeroTotalPrice = () => {
    const isPrimeUserLabel = getSelectedOption() === 'prime' ? 'prime' : 'nonprime';
    const isLoggedUserLabel = isUserLogged() ? 'logged' : 'notlogged';
    trackingUtils.trackEvent('payment_price_error', `payment-price-error_onload_user:${isPrimeUserLabel}_logged:${isLoggedUserLabel}_pag:pay`);
};

const toggleContinueToPrimeWidgetButton = (show) => {
    if (show) {
        trackOncePerPolicy($selectors.continueToPrimeWidgetButton);
    }
    $selectors.continueToPrimeWidgetButton.toggleClass('odf-hidden', !show);
    $selectors.continueToPrimeWidgetButtonContainer.toggleClass('odf-hidden', !show);
};

const toggleContinueToPaymentFormButton = (show) => {
    $selectors.continueToPaymentFormButton.toggleClass('odf-hidden', !show);
    $selectors.continueToPaymentFormButtonContainer.toggleClass('odf-hidden', !show);
};

const toggleMembershipAutoApplyDiscount = (show) => {
    $selectors.oldMembershipAutoApplyDiscount.toggleClass('odf-hidden', !show);
};

const bindContinueToPrimeWidgetButtonClickEvent = () => {
    $selectors.continueToPrimeWidgetButton.off(Odigeo.Events.tap + continueToPrimeWidgetNamespace);
    $selectors.continueToPrimeWidgetButton.on(Odigeo.Events.tap + continueToPrimeWidgetNamespace, Odigeo._.bind((event) => {
        trackingUtils.trackEvent('ancillaries_step', 'proceed_to_payment', 'ancillaries');
        trackClickEvent(event);
        trackPrice();
        if (Odigeo.getWidgetByID('ancillaries-module')) {
            checkMandatorySelectionAncillariesModule();
        } else {
            openPrimeWidgetStep();
        }
    }, this));
};

const bindContinueToPaymentFormClickEvent = () => {
    $selectors.continueToPaymentFormButton.off(Odigeo.Events.tap + continueToPaymentFormNamespace);
    $selectors.continueToPaymentFormButton.on(Odigeo.Events.tap + continueToPaymentFormNamespace, Odigeo._.bind(() => {
        onContinueToPaymentEvent();
    }, this));
};

const onCollapsePaymentForm = () => {
    hidePaymentForm();
};

const onContinueToPaymentEvent = () => {
    toggleContinueToPaymentFormButton(false);
    openStep();
    setStepHasAlreadyOpened();
    if (isPrimeModuleFromShell) {
        scrollToMembershipSectionKnowMoreLink();
    }
    tagManagement.sendEvent('step_payment_method');
};

const bindStepButtonClickEventEvo = () => {
    $selectors.stepButton.off(Odigeo.Events.tap + ancillariesStepNamespace);
    $selectors.stepButton.on(Odigeo.Events.tap + ancillariesStepNamespace, Odigeo._.bind((event) => {
        setStepHasAlreadyOpened();
        checkMandatorySelection();
        trackClickEvent(event);
    }, this));
};

const isAncillariesStepEnabled = () => $selectors.paymentForm.size() > 0;

const isAncillariesStepOpened = () => $selectors.stepButton.hasClass('odf-hidden');

const addSoBasicIfNotAdded = (addSoBasic) => {
    if (addSoBasic && Odigeo.getWidgetByID('so-table')) {
        widgets.getServiceoptionsTableManager().execute('addSoBasicIfNotAdded');
    }
};

const toggleShowMembershipAncillariesWidget = () => {
    Odigeo.trigger('ancillariesStep:toggleShowMembershipAncillariesWidget');
};

const toggleShowSubscriptionManagerDesktopContainer = () => {
    Odigeo.trigger('ancillariesStep:toggleShowSubscriptionManagerDesktopContainer');
};

const toggleShowMembershipRecaptureWidget = () => {
    Odigeo.trigger('ancillariesStep:toggleShowMembershipRecaptureWidget');
};

const scrollToSubscriptionManagerDesktopContainer = () => {
    Odigeo.trigger('ancillariesStep:scrollToSubscriptionManagerDesktopContainer');
};

const scrollToMembershipSectionKnowMoreLink = () => {
    Odigeo.trigger('ancillariesStep:scrollToMembershipSectionKnowMoreLink');
};

const updateFreeCanxTextsVisibility = () => {
    insuranceCatalogueCollection.getLoadedPromise().then((loaded) => {
        if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
            showStepButton();
        }
        if (loaded && !insuranceCatalogueCollection.isCancellationFree()) {
            showChangeFlightFreeChargeStepButtonText();
        }
    });
};

const showChangeFlightFreeChargeStepButtonText = () => {
    const shouldShowFlightChangeFreeMessage =
        (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays) &&
        flightChangeFreeUtil.isSelectedFlightChangeableForFree();
    if (shouldShowFlightChangeFreeMessage) {
        $selectors.stepButtonChangeFlightFreeChargeContainerText.removeClass('odf-hidden');
    }
};

const showStepButton = () => {
    $selectors.stepButtonContainerTitle.removeClass('odf-hidden');
    $selectors.stepButtonContainerSubtitle.removeClass('odf-hidden');
};

const toggleMembershipFlexibility = (show) => {
    $selectors.membershipFlexibilityTripDetails = $selectors.membershipFlexibilityTripDetails.length ?
        $selectors.membershipFlexibilityTripDetails : $('.flight_flexibility_banner');

    $selectors.membershipFlexibilityButtonLabelIncluded.toggleClass('odf-hidden', !show);
    $selectors.membershipFlexibilityButtonLabelExcluded.toggleClass('odf-hidden', show);
    $selectors.membershipFlexibilitySidebar.toggleClass('odf-hidden', !show);
    $selectors.membershipFlexibilityTripDetails.toggleClass('odf-hidden', !show);
};

const isPrimeAccountStored = () => {
    const secureStore = store.getStore();
    return secureStore
        && secureStore.prime
        && isPrimeAccount(secureStore.prime.userStatus);
};

const isPrimeRecaptureCustomersDesktopStore = () => Odigeo._.get(store.getStore(), 'prime.membershipSubscriptionDetails.reactivatePrime', false);

const isPrimeWidgetStep = () => {
    const {isMembershipProductEnabledDesktop,
        isPrimeRecaptureCustomersDesktop,
        isFreeTrialMetaRevampDesktop} = Odigeo.Membership;
    const isMeta = Odigeo.SessionScope.isMeta;
    const isRecaptureCustomersDesktop = isPrimeRecaptureCustomersDesktop || isPrimeRecaptureCustomersDesktopStore();
    const isPrimeAccount = isPrimeAccountStored();
    const isAcquisitionComponent = !isPrimeAccount && ((isMembershipProductEnabledDesktop && !isMeta) || (isFreeTrialMetaRevampDesktop));
    return isAcquisitionComponent || isRecaptureCustomersDesktop;
};

const openAncillariesStep = () => {
    isPrimeWidgetStep() ? openPrimeWidgetStep() : openStep();
};

const toggleLegacyPrimeModule = (isHideLegacyPrimeModule) => {
    $selectors.oldPrimeModuleSection.toggleClass('odf-hidden', isHideLegacyPrimeModule);
    if (isHideLegacyPrimeModule) {
        hideStepButton();
    }
};

const setIsPrimeModuleFromShell = (isMembershipSectionFromShell) => {
    isPrimeModuleFromShell = isMembershipSectionFromShell;
    toggleLegacyPrimeModule(isMembershipSectionFromShell);
    toggleShowSubscriptionManagerDesktopContainer();
};

module.exports = {
    init: () => {
        if (isAncillariesStepEnabled()) {
            initStep();
        } else if (isPrimeWidgetStep() && !getPrimeWidgetStepOpenFirstTimeSessionItem()) {
            initFlags();
            hidePaymentForm();
            bindContinueToPaymentFormClickEvent();
            openPrimeWidgetStep();
        }
    },
    isEnabled: isAncillariesStepEnabled,
    isOpened: isAncillariesStepOpened,
    openAncillariesStep: openAncillariesStep,
    setSkipByRebooking: (value) => skipInsurancesContinueNagByRebooking = value,
    setSkipByCanx: (value) => skipInsurancesContinueNagByCanx = value,
    toggleMembershipFlexibility,
    onContinueToPaymentEvent,
    onCollapsePaymentForm,
    setIsPrimeModuleFromShell,
};
